import { useMemo } from 'react';
import { useFxCurrencies } from '@/hooks/react-query/useFxRates';
import type { FxCurrency } from '@/types/fx-rates';

type CurrencyMetaByCode = Record<string, FxCurrency>;

const buildCurrencyMetaByCode = (currencies: FxCurrency[]): CurrencyMetaByCode =>
  currencies.reduce<CurrencyMetaByCode>((acc, currency) => {
    acc[currency.iso_code.toUpperCase()] = currency;
    return acc;
  }, {});

export const useFxCurrencySymbols = () => {
  const { data: currencies = [], isLoading, error } = useFxCurrencies();

  const currencyMetaByCode = useMemo(
    () => buildCurrencyMetaByCode(currencies),
    [currencies]
  );

  const getSymbol = (currencyCode?: string | null) => {
    if (!currencyCode) return '';
    return currencyMetaByCode[currencyCode.toUpperCase()]?.symbol || '';
  };

  return {
    currencies,
    currencyMetaByCode,
    getSymbol,
    isLoading,
    error,
  };
};
